import { useState } from 'react';
import { submitContact } from '@/lib/api';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'done' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const canSubmit = name.trim() !== '' && email.trim() !== '' && message.trim() !== '' && status !== 'submitting';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;
    setStatus('submitting');
    setErrorMessage('');
    const result = await submitContact({ name, email, message });
    if (result.ok) {
      setStatus('done');
      setName('');
      setEmail('');
      setMessage('');
    } else {
      setStatus('error');
      setErrorMessage(result.error ?? '送信に失敗しました。時間をおいて再度お試しください。');
    }
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">
        <div className="bg-secondary-50 py-16 px-6 text-center">
          <p className="text-xs tracking-[0.3em] text-primary-500 mb-3 uppercase"
            style={{ fontFamily: "var(--font-heading)" }}>
            Contact
          </p>
          <h1 className="text-4xl md:text-6xl font-light text-foreground-950"
            style={{ fontFamily: "var(--font-heading)" }}>
            お問い合わせ
          </h1>
        </div>

        <div className="max-w-2xl mx-auto px-6 py-14">
          {status === 'done' ? (
            <div className="border border-background-200 rounded-xl p-8 text-center">
              <p className="text-base text-foreground-900 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
                送信しました
              </p>
              <p className="text-sm text-foreground-600 leading-relaxed" style={{ fontFamily: "var(--font-body)" }}>
                お問い合わせいただきありがとうございます。内容を確認の上、追ってご連絡いたします。
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <p className="text-sm text-foreground-600 leading-relaxed" style={{ fontFamily: "var(--font-body)" }}>
                ご注文内容の変更、不良品・誤発送のご連絡、その他のお問い合わせは、以下のフォームよりご連絡ください。
              </p>

              <div>
                <label className="block text-xs text-foreground-700 tracking-[0.15em] mb-2 uppercase" style={{ fontFamily: "var(--font-heading)" }}>
                  お名前 <span className="text-primary-500">*</span>
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={e => setName(e.target.value)}
                  required
                  className="w-full border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-900 focus:outline-none focus:border-primary-400"
                  style={{ fontFamily: "var(--font-body)" }}
                />
              </div>

              <div>
                <label className="block text-xs text-foreground-700 tracking-[0.15em] mb-2 uppercase" style={{ fontFamily: "var(--font-heading)" }}>
                  メールアドレス <span className="text-primary-500">*</span>
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  className="w-full border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-900 focus:outline-none focus:border-primary-400"
                  style={{ fontFamily: "var(--font-body)" }}
                />
              </div>

              <div>
                <label className="block text-xs text-foreground-700 tracking-[0.15em] mb-2 uppercase" style={{ fontFamily: "var(--font-heading)" }}>
                  お問い合わせ内容 <span className="text-primary-500">*</span>
                </label>
                <textarea
                  value={message}
                  onChange={e => setMessage(e.target.value)}
                  required
                  rows={6}
                  className="w-full border border-background-300 rounded-lg px-4 py-3 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 resize-none"
                  style={{ fontFamily: "var(--font-body)" }}
                />
              </div>

              {status === 'error' && (
                <p className="text-sm text-primary-600">{errorMessage}</p>
              )}

              <button
                type="submit"
                disabled={!canSubmit}
                className={`w-full py-4 text-sm tracking-[0.2em] transition-all whitespace-nowrap cursor-pointer rounded-full ${
                  canSubmit ? 'bg-primary-500 text-white hover:bg-primary-600' : 'bg-background-200 text-foreground-400 cursor-not-allowed'
                }`}
                style={{ fontFamily: "var(--font-heading)" }}
              >
                {status === 'submitting' ? '送信中...' : '送信する'}
              </button>
            </form>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
